import React from 'react';

import './titleabout.scss'
import { Link } from 'react-router-dom';

export default function TitleAbout({children, name, link1, link2}){
  return(
    <>
      <div>
        <section className='box-about-title'>
          <div className='container'>
            <div className='box'>
              <div style={{width: '2px', height: '2.5em' , backgroundColor: '#707070'}} 
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              </div>
              <div>
                {children}
                <span
                  data-aos="fade-down"
                  data-aos-duration="2000">
                  {name}
                </span>
                <div className="links" 
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  {children}
                  <Link to="/">{link1}</Link>
                  <Link to="#">{link2}</Link>
                </div>
                {/* <Typography variant='h4'>
                Sobre a Séculos
                </Typography> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}